import { useModalStore } from "@/stores/use-modal-store";
import { cn } from "@/utils/classes";
import { useCallback, useRef } from "react";
import { useEffect } from "react";

/*
 * Modal component
 */
export const Modal = () => {
  /* Stores */
  const { close } = useModalStore((state) => state.modalActions);
  const { isOpen, content, config } = useModalStore();

  /* Consts */
  const { className = "", closeOnClickOutside = true } = config;

  /* Refs */
  const modalRef = useRef<HTMLDialogElement>(null);

  /* Handlers */
  const handleKeyDown = useCallback(
    (e: KeyboardEvent) => {
      if (e.key === "Escape" && isOpen) {
        close();
      }
    },
    [isOpen, close],
  );

  /* Set up and clean up the event listener */
  useEffect(() => {
    /* Only add listener when modal is open */
    if (isOpen) {
      document.addEventListener("keydown", handleKeyDown);
      /* Focus the modal for accessibility */
      modalRef.current?.focus();
    }

    /* Clean up */
    return () => {
      document.removeEventListener("keydown", handleKeyDown);
    };
  }, [isOpen, handleKeyDown]);

  /* Render */
  return (
    <dialog
      open={isOpen}
      ref={modalRef}
      className={cn("modal overflow-hidden", {
        "modal-open": isOpen,
      })}
    >
      <div className={cn("modal-box relative z-50", className)}>{content}</div>
      {closeOnClickOutside && (
        <form method="dialog" className="modal-backdrop">
          <button type="button" className="cursor-default bg-transparent border-none outline-hidden rounded-none w-screen h-screen" onClick={close}>
            close
          </button>
        </form>
      )}
    </dialog>
  );
};
